import { COMPONENT_RECYCLERVIEW_GRID } from "../constants/typeConstants";
import common from "./common";
/**
 * factory function to produce Customizable Grid Layout Component Object
 * @param {String} name
 * @param {Array} children array
 */
export default function(name = "Customizable Grid Layout", children = []) {
  let obj = {
    name: name,
    type: COMPONENT_RECYCLERVIEW_GRID,
    children: children
  };
  return Object.assign(obj, common);
}
